import { render, staticRenderFns } from "./releaseArticle.vue?vue&type=template&id=396d7d94&scoped=true"
import script from "./releaseArticle.vue?vue&type=script&lang=js"
export * from "./releaseArticle.vue?vue&type=script&lang=js"
import style0 from "./releaseArticle.vue?vue&type=style&index=0&id=396d7d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d7d94",
  null
  
)

export default component.exports